<template>
    <section>
      <ul class="filters-list">
        <li>
          <router-link
            :to="{
              name: 'LabdaqPendingOrders',
              query: this.$route.query,
            }"
          >
            LABDAQ ORDERS
            <span class="active-icon">
              <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
          ></router-link>
        </li>
        <li>
          <router-link
            :to="{
              name: 'LabdaqPendingResults',
              query: this.$route.query,
            }"
          >
          LABDAQ RESULTS
            <span class="active-icon">
              <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
          ></router-link>
        </li>
        <li>
          <router-link
            :to="{
              name: 'LabdaqInvalidOrders',
              query: this.$route.query,
            }"
          >
          LABDAQ INVALID
            <span class="active-icon">
              <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
          ></router-link>
        </li>
        <li>
          <router-link
            :to="{
              name: 'LabdaqCompletedOrders',
              query: this.$route.query,
            }"
          >
          LABDAQ FINALIZED
            <span class="active-icon">
              <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
          ></router-link>
        </li>
      </ul>
    </section>
  </template>
  